import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AlertType } from '@libs/models/alert.models';

@Component({
  selector: 'app-alert-modal',
  templateUrl: './alert-modal.component.html',
  styleUrls: ['./alert-modal.component.scss'],
  standalone: false,
})
export class AlertModalComponent {
  @Input() type: AlertType = AlertType.SUCCESS;
  @Input() title = '';
  @Input() description = '';
  @Input() confirmText?: string;
  @Input() cancelText?: string;
  @Input() descriptionHtml?: string;
  @Input() isImage?: boolean;

  constructor(private modalCtrl: ModalController) { }

  get headerColor(): 'success' | 'danger' {
    return this.type === 'error' ? 'danger' : 'success';
  }

  onConfirm(): void {
    this.modalCtrl.dismiss(true, 'confirm');
  }

  onCancel(): void {
    this.modalCtrl.dismiss(false, 'cancel');
  }

  onClose(): void {
    this.modalCtrl.dismiss(false, 'close');
  }
}
